import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Modal, Box, Typography, Grid, TextField, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDialogState } from 'hooks/useDialogState';
import MyPageStore from '../store/MyPageStore';
import useSnackbarMessage from 'shared/snackbar';
import CloseIcon from '../../../assets/image/close.png';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '15px',
  paddingTop: '30px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  minWidth: '90vw',
};

const ValidationTextField = styled(TextField)({
  '& fieldset': {
    border: '1px solid #dddddd',
    borderRadius: '10px',
    width: '100%',
  },
});

interface Props {
  pageStore: MyPageStore;
}

function MyPageGoalModal(props: Props) {
  const { pageStore } = props;
  const snackbar = useSnackbarMessage();

  const handleClose = () => {
    // closeDialog();
    pageStore.setMyInfoQuarter(pageStore.myInfo.userData.quarterGoal ?? '');
    pageStore.setMyInfoSemi(pageStore.myInfo.userData.semiAnnualGoal ?? '');
    pageStore.setIsOpenModal(false);
  };

  const handleChangeInputQuarter = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    pageStore.setMyInfoQuarter(e.target.value);
  };

  const handleChangeInputSemi = (e: React.ChangeEvent<HTMLInputElement>) => {
    pageStore.setMyInfoSemi(e.target.value);
  };

  const handleClickSaveBtn = async () => {
    try {
      if (pageStore.quarterGoal === '' && pageStore.semiAnnualGoal === '') {
        return;
      }
      await pageStore.save();
      handleClose();
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  return pageStore.isLoading ? (
    <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
      <CircularProgress />
    </Grid>
  ) : (
    <Modal open={pageStore.isOpenModal} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
      <Box sx={style}>
        <Grid container justifyContent={'center'}>
          <Grid container justifyContent={'center'}>
            <Typography
              style={{
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '14px',
                textAlign: 'center',
                marginBottom: '30px',
              }}
            >
              Goals
            </Typography>
          </Grid>
          <Grid container justifyContent={'center'}>
            <Grid container>
              <Typography
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  lineHeight: '14px',
                  color: '#212121',
                }}
              >
                분기 목표
              </Typography>
            </Grid>
            <Grid style={{ width: '100%', marginTop: '12px' }}>
              <ValidationTextField
                rows={4}
                id='message'
                name='message'
                type='text'
                margin='dense'
                InputProps={{
                  style: {
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 400,
                    border: 'none',
                    width: '100%',
                  },
                }}
                style={{
                  width: '100%',
                }}
                multiline
                defaultValue={pageStore.quarterGoal}
                onChange={handleChangeInputQuarter}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={'center'}>
            <Grid container>
              <Typography
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  lineHeight: '14px',
                  color: '#212121',
                  marginTop: '24px',
                }}
              >
                반기 목표
              </Typography>
            </Grid>
            <Grid style={{ width: '100%', marginTop: '12px' }}>
              <ValidationTextField
                rows={4}
                id='message'
                name='message'
                type='text'
                margin='dense'
                InputProps={{
                  style: {
                    fontSize: '14px',
                    lineHeight: '21px',
                    fontWeight: 400,
                    border: 'none',
                    width: '100%',
                  },
                }}
                style={{
                  width: '100%',
                }}
                multiline
                defaultValue={pageStore.semiAnnualGoal}
                onChange={handleChangeInputSemi}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent={'space-between'} style={{ marginTop: '30px' }}>
            <Button
              style={{
                border: '1px solid #dddddd',
                borderRadius: '25px',
                background: '#ffffff',
                color: '#000000',
                textTransform: 'unset',
                boxShadow: 'none',
                fontFamily: 'Pretendard',
                fontSize: '16px',
                lineHeight: '16px',
                fontWeight: 400,
                padding: '17px 50px',
              }}
              onClick={handleClose}
              variant='contained'
            >
              Close
            </Button>
            <Button
              style={{
                border: '1px solid #dddddd',
                borderRadius: '25px',
                textTransform: 'unset',
                boxShadow: 'none',
                background: '#2281D0',
                color: '#ffffff',
                fontFamily: 'Pretendard',
                fontSize: '16px',
                lineHeight: '16px',
                fontWeight: 400,
                padding: '17px 50px',
              }}
              onClick={handleClickSaveBtn}
              variant='contained'
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <img src={CloseIcon} style={{ position: 'absolute', right: '18px', top: '18px', cursor: 'pointer' }} onClick={handleClose} alt='closeIcon' />
      </Box>
    </Modal>
  );
}

export default observer(MyPageGoalModal);
